//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

  import { mapMutations } from 'vuex'
  export default {
    name:'WETFAG',
    data() {
      return {
        defaultJson:{
	        "Energy": "能量",
          "Glucose 10%": "10% 葡萄糖",
          "Tube Size": "导管尺寸",
          "Adrenaline": "肾上腺素",
          "Weight": "体重",
          "Predicted Weight": "预测体重",
          "Fluid Bolus": "液体负荷",
          "Age": "年龄"
        },
        form:{
          age:'',
          weight:'',
        },
        hasScore:false,
        disabled:false,
        computedweight:'--',
        energy:'--',
        tube:'--',
        fluid:'--',
        adre:'--',
        glucose:'--',
        age:''
      }
    },
    created () {
      this.hideLoad()
    },
    methods: {
      ...mapMutations(['hideLoad']),
    },
    computed: {
      /** 计算公式结果 */
      score() {
        let self = this
        let form = JSON.parse(JSON.stringify(self.form))
        let flag = true
        for (const key in form) {
          if (form.hasOwnProperty(key)) {
            if (!form[key]) {
              flag = false
            } else { 
              if (form[key]=='---') {
                flag = false
              } else {  
                form[key] = Number(form[key])
              }
            }
          }
        }
        if (!flag) {
          self.hasScore = false
          return '--'
        } else {
          // age <6 ? ((2*age)+8) : ((3*age)+7)
          self.computedweight = form.age <6 ? ((2*form.age)+8) : ((3*form.age)+7)
          // 4*weight
          self.energy = 4*form.weight
          // floor(((age/4)+4)*2)/2
          self.tube = Math.floor(((form.age/4)+4)*2)/2
          // 20*weight
          self.fluid = 20*form.weight
            // 0.1*weight
          self.adre = 0.1*form.weight
          // 5*weight
          self.glucose = 5*form.weight
          console.log(self.glucose,'self.glucose');

          let result = self.energy
          
          self.hasScore = true
          return String(result.toFixed(0))
        }
      }
    },
    
    
  }



// WEBPACK FOOTER //
// ./src/pages/formulas/Pedi/WETFAG.vue